<template>
  <div class="optical-tweezers-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>F_grad = α · ∇(E²) | 辐射压力捕捉$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Laser Beam (Highly focused) -->
          <path d="M 150,0 Q 200,120 250,0" fill="none" stroke="rgba(255, 71, 87, 0.2)" stroke-width="60" />
          <path d="M 180,0 Q 200,120 220,0" fill="none" stroke="#ff4757" stroke-width="4" opacity="0.6" />
          
          <!-- The Trapped Particle -->
          <g :transform="`translate(${particlePos.x}, ${particlePos.y})`">
             <circle r="12" fill="rgba(0, 210, 255, 0.4)" stroke="#00d2ff" stroke-width="2" />
             <text x="15" y="0" fill="#00d2ff" font-size="8">微球 (如细胞/聚苯乙烯)</text>
             
             <!-- Scattering vectors -->
             <path v-if="isTrapped" d="M -15,0 L -30,10 M -15,0 L -30,-10" stroke="#ff4757" stroke-width="1" />
             <path v-if="isTrapped" d="M 15,0 L 30,10 M 15,0 L 30,-10" stroke="#ff4757" stroke-width="1" />
          </g>

          <text x="230" y="125" fill="#ff4757" font-size="10">焦点 (势阱中心)</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>状态: {{ isTrapped ? '已被光学锁定' : '自由布朗运动' }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
           <el-button type="primary" size="mini" @click="toggleTrap">{{ isTrapped ? '关闭激光 (释放)' : '开启激光 (捕捉)' }}</el-button>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>光镊是2018年诺贝尔物理学奖的技术成果。它利用高度聚焦的激光束产生的**辐射压力**和**梯度力**。当微小颗粒（如单个细胞、DNA片段）偏离焦点时，光子在折射过程中发生的动量改变会对颗粒产生一个指向焦点的回馈力。这使得科学家可以用光束精准地“夹住”并操纵微观物体，而不会造成机械损伤。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OpticalTweezersViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      particlePos: { x: 50, y: 180 },
      isTrapped: false,
      timer: null
    }
  },
  methods: {
    update() {
       if (this.isTrapped) {
          // Trap logic: pull towards (200, 120) with jiggle
          this.particlePos.x += (200 - this.particlePos.x) * 0.1 + (Math.random()-0.5)*2;
          this.particlePos.y += (120 - this.particlePos.y) * 0.1 + (Math.random()-0.5)*2;
       } else {
          // Random walk
          this.particlePos.x += (Math.random()-0.5)*3;
          this.particlePos.y += (Math.random()-0.5)*3;
          // Boundary
          if (this.particlePos.x < 20) this.particlePos.x = 20;
          if (this.particlePos.x > 380) this.particlePos.x = 380;
          if (this.particlePos.y < 20) this.particlePos.y = 20;
          if (this.particlePos.y > 220) this.particlePos.y = 220;
       }
       this.timer = requestAnimationFrame(this.update);
    },
    toggleTrap() {
       this.isTrapped = !this.isTrapped;
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.optical-tweezers-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
